// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"BlogPost_blogPost__pfHKS","header":"BlogPost_header__cPax7","content":"BlogPost_content__N_pcC"};